"use client";

import { blogPage } from "@faire/retailer-visitor-shared/paths/index";
import { useLocalization } from "@faire/web/common/localization/useLocalization";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import { trackLoggedOutRetailersDeepLinkBlogClick } from "@faire/web-api--source/events/loggedOutRetailers/click/deepLinkBlog";
import React from "react";

import { HeaderAnchor } from "../styled";

export const BlogEntryLink = () => {
  const {
    intl: { locale },
  } = useLocalization();
  return (
    <HeaderAnchor
      href={`${blogPage(locale)}/`}
      data-test-id="blogEntryButton"
      onClick={() =>
        trackLoggedOutRetailersDeepLinkBlogClick("blog", "desktop")
      }
    >
      <StrictLocalMsg
        defaultMessage="Blog"
        description={{
          text: "title of link that leads to faire's blog page",
          img: "https://cdn.faire.com/fastly/4c5aaa52dda15b0270c374a7e3233e825bb47aecdc8bd8b533699e960093d3a5.png",
        }}
      />
    </HeaderAnchor>
  );
};
